<template>
  <div style="position: relative; width: 94px; min-height: 30px;">
    <CInput
      type="time"
      maxlength="5"
      style="margin-bottom: 3px; width: 94px"
      :value="displayValue"
      @input="onInput"
      :tabindex="tabindex"
      @focus="onFocus"
      @blur="onBlur"
    />
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "RestInput",
  props: {
    rest: String,
    index: Number,
    postBuffer: String,
    breakBasic: String,
    flg: Boolean,
    isHoliday: Boolean,
    actualEnd: String,
    endBasic: String,
    tabindex: Number,
    label: String,
  },
  emits: ["update-rest", "focus", "blur"],
  computed: {
    displayValue() {
        const isValidTime = (v) => /^\d{2}:\d{2}$/.test(v);
        // 正しい形式のときだけその値を返す
        if (isValidTime(this.rest)) {
          return this.rest;
        }

        // 休日や有給休暇、代休、欠勤の場合は休憩時間を空文字を返す
        if(this.isHoliday) {
          return "";
        }

        const base = moment.duration(this.breakBasic, "HH:mm");
        const buf = moment.duration(this.postBuffer ?? "00:00", "HH:mm");

        const end = isValidTime(this.actualEnd) ? moment.duration(this.actualEnd, "HH:mm") : null;
        const endBase = isValidTime(this.endBasic) ? moment.duration(this.endBasic, "HH:mm") : null;

        let total = base.clone();

        if (this.flg && end && endBase) {
          const diffMin = end.asMinutes() - endBase.asMinutes();
          const bufferMin = buf.asMinutes();

          if (diffMin === 0) {
            // 定時退勤 → breakBasicのみ
          } else if (diffMin >= bufferMin) {
            // バッファちょうど、または超えた → バッファ分追加
            total.add(buf);
          } else if (diffMin > 0) {
            // バッファ未満 → 差分追加
            total.add(moment.duration(diffMin, "minutes"));
          }
        }

        const h = String(total.hours()).padStart(2, "0");
        const m = String(total.minutes()).padStart(2, "0");
        return `${h}:${m}`;
    }
  },
  methods: {
    onInput(val) {
      this.$emit("update-rest", { index: this.index, value: val });
    },
    onFocus() {
      this.$emit("focus");
    },
    onBlur() {
      this.$emit("blur"); // 👈 update-rest は emit しない
    }
  },
  watch: {
  displayValue: {
    immediate: true,
    handler() {
      // 休憩時間が未入力なら自動計算値をemit
      if (!this.rest || this.rest === "") {
        const value = this.displayValue;
        if (/^\d{2}:\d{2}$/.test(value)) {
          this.$emit("update-rest", { index: this.index, value });
        }
      }
    }
  }
},
};
</script>
